// Mock data for Bombay Home Gallery

export const contactInfo = {
  phone: '9321233008',
  whatsapp: '9321233008',
  email: 'bombayhomegallery@gmail.com',
  address: 'Hardoi road, opposite Azad patakhe, Haji Colony, Mahipatmau, Lucknow, Uttar Pradesh 226003',
  mapUrl: 'https://share.google/KW154EeRvZd4mrQEJ',
  googleMaps: 'https://share.google/KW154EeRvZd4mrQEJ',
  website: 'www.bombayhomegallery.com',
  instagram: 'https://www.instagram.com/bombay_home_gallery/',
  facebook: 'https://www.facebook.com/bombayhomegallery',
  businessHours: 'Open all days: 10:00 AM - 08:30 PM'
};

export const founderInfo = {
  name: 'Akhand Pratap',
  title: 'Founder & Material Consultant',
  qualification: 'Civil Engineer with Master\'s in Construction Management',
  experience: 'More than a decade of experience in construction & interior materials',
  tagline: 'Your Material Consultant for Smart Home Building',
  image: '/founder-akhand-pratap.jpg',
  bio: 'Akhand Pratap is a seasoned Civil Engineer with a Master\'s degree in Construction Management and over a decade of hands-on experience in the building, design, and interior space. Having worked extensively across various high-demand residential and commercial projects in Mumbai and other metro cities, and now serving clients in his home-region Lucknow, he brings a unique mix of metropolitan exposure and regional sensibility.'
};

export const productCategories = [
  {
    id: 1,
    name: 'Plumbing Essentials',
    slug: 'plumbing',
    description: 'Quality plumbing solutions for lasting performance',
    image: 'https://images.unsplash.com/photo-1650246363606-a2402ec42b08',
    products: [
      'CPVC Pipes & Fittings',
      'PVC Pipes & Systems',
      'Water Storage Tanks',
      'Drainage Solutions'
    ]
  },
  {
    id: 2,
    name: 'Tiles & Surfaces',
    slug: 'tiles-surfaces',
    description: 'Premium tiles for every space in your home',
    image: 'https://images.unsplash.com/photo-1760681555321-f0e05f50410c',
    products: [
      'Vitrified Tiles',
      'Ceramic Tiles',
      'Porcelain Tiles',
      'Moroccan & Designer Tiles',
      'Floor & Wall Tiles',
      'Designer & Digital Tiles',
      'Parking Tiles',
      'Slabs & Plank Tiles',
      'Elevation Tiles',
      'Matt Finish Tiles',
      'Sugar Finish Tiles',
      'Carving Tiles',
      'Full Body Tiles',
      'Double Charge Tiles',
      'Tile Adhesives',
      'Tile Allied Products'
    ]
  },
  {
    id: 3,
    name: 'Bathroom & Sanitary Solutions',
    slug: 'bathroom-sanitary',
    description: 'Complete bathroom solutions from trusted brands',
    image: 'https://images.unsplash.com/photo-1564540579594-0930edb6de43',
    products: [
      'EWCs (European Water Closets)',
      'Designer Washbasins',
      'Vanities',
      'LED Mirrors',
      'Designer Mirrors',
      'CP Fittings (Taps, Showers, Accessories)',
      'Kitchen Sinks (Handmade, Branded, Soundless, Metal)'
    ]
  },
  {
    id: 4,
    name: 'Designer Interior Finishes',
    slug: 'designer-finishes',
    description: 'Premium finishes and designer solutions for luxury homes',
    image: 'https://images.unsplash.com/photo-1770625467797-e1945217b73a',
    products: [
      'Designer Basins & Washbasins',
      'Premium Faucets & Taps',
      'Charcoal Louvers',
      'Charcoal Panels',
      'UV Sheets',
      'PU Feather Panels',
      'Customized Wallpapers',
      'PVC Panels',
      'Decorative Wall Panels',
      'Designer Wall Cladding'
    ]
  },
  {
    id: 5,
    name: 'Premium Paints by Birla Opus',
    slug: 'paints',
    description: 'Exclusive Birla Opus premium paints collection',
    image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828',
    products: [
      'Birla Opus Luxury Interior Emulsions',
      'Birla Opus Exterior Paints',
      'Textured & Designer Paints',
      'Eco-Friendly Paint Solutions',
      'Stain-Resistant Coatings',
      'Washable Wall Finishes',
      'Special Effect Paints',
      'Premium Quality Primers'
    ]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Expert Guidance',
    description: 'Professional consultation from a civil engineer with construction management expertise',
    icon: 'UserCheck',
    image: 'https://static.prod-images.emergentagent.com/jobs/eb3e1544-7565-450f-a2a0-dd9eccd226a4/images/e0e1792edf2ecc599474ba0acf63858c3e66ada64ec4be24ce05ecf6ec8e5454.png'
  },
  {
    id: 2,
    title: 'Premium Quality',
    description: 'Only branded and certified products ensuring durability and excellence',
    icon: 'Award',
    image: 'https://images.unsplash.com/photo-1767091116911-afd6612c53c6'
  },
  {
    id: 3,
    title: 'Wide Variety',
    description: 'Extensive range of tiles, bathroom fittings, and plumbing materials under one roof',
    icon: 'Grid3x3',
    image: 'https://images.unsplash.com/photo-1648475237029-7f853809ca14'
  },
  {
    id: 4,
    title: 'Competitive Pricing',
    description: 'Luxury and quality at affordable prices, transparent pricing with no hidden costs',
    icon: 'Tag',
    image: 'https://images.unsplash.com/photo-1709544540487-4578f9e53ffd'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Sharma',
    role: 'Homeowner',
    content: 'Bombay Home Gallery provided excellent guidance for my home renovation. The quality of tiles and bathroom fittings is outstanding!',
    rating: 5
  },
  {
    id: 2,
    name: 'Priya Verma',
    role: 'Interior Designer',
    content: 'As a designer, I always recommend Bombay Home Gallery to my clients. Their variety and quality are unmatched in Lucknow.',
    rating: 5
  },
  {
    id: 3,
    name: 'Amit Singh',
    role: 'Contractor',
    content: 'Reliable partner for all my projects. Akhand\'s technical expertise makes material selection so much easier.',
    rating: 5
  }
];

export const heroImages = [
  'https://images.unsplash.com/photo-1720540244592-b4124532b318',
  'https://images.unsplash.com/photo-1724582586529-62622e50c0b3',
  'https://images.unsplash.com/photo-1628744876497-eb30460be9f6'
];

export const problemsSolved = [
  'Navigate design decisions with confidence',
  'Access premium quality at fair prices',
  'Choose from only certified, branded products',
  'Receive expert technical guidance',
  'Find everything under one roof'
];

export const ebookInfo = {
  title: 'Premium Homebuilding Guide',
  subtitle: 'Your Guide to Smarter Homebuilding Decisions',
  description: 'The ultimate guide for smart homeowners, packed with insider knowledge on planning, budgeting, legal approvals, material selection, and interior finishing.',
  author: 'Akhand Pratap',
  pdfUrl: '/ebook-hidden-costs.pdf',
  coverImage: 'https://images.unsplash.com/photo-1639664701039-f747268e2243',
  features: [
    'Pre-Construction Wisdom & Planning Tips',
    'Legal & Government Approvals',
    'Plot Planning & Orientation',
    'Budget vs. Design Balance',
    '5S Smart Selection Framework',
    'Build a Winning Team',
    'Full Construction Timeline',
    'Material Buying Timeline',
    'Interior Styling & Smart Home',
    'Post-Handover Maintenance'
  ],
  benefits: [
    'Optimize budgeting and cost control with accurate forecasting',
    'Avoid legal and approval pitfalls in construction',
    'Make data-driven selections with the 5S framework',
    'Learn sustainable, energy-conscious strategies',
    'Incorporate modular and smart home design seamlessly'
  ],
  perfectFor: [
    'First-time homebuilders and custom home enthusiasts',
    'DIY homeowners seeking smart home planning',
    'Architecture-savvy families wanting to balance Vastu and functionality',
    'Anyone planning a modular kitchen or smart home features'
  ]
};

export const faqData = [
  {
    question: 'What brands do you carry at Bombay Home Gallery?',
    answer: 'We stock only premium, certified brands including Kajaria, Parryware, Hindware, Astral, Birla Opus Paints, Roff, Plumber Bathware, and Supreme Pipes. Every product comes with manufacturer warranty and quality assurance.'
  },
  {
    question: 'Do you provide installation services for tiles and sanitary ware?',
    answer: 'While we specialize in material supply and expert consultation, we can recommend trusted installation partners in Lucknow. Our team also provides technical guidance to ensure proper installation of all products.'
  },
  {
    question: 'How do I choose the right tiles for my space?',
    answer: 'Our founder Akhand Pratap, a civil engineer with construction management expertise, offers personalized consultations. We consider factors like room usage, foot traffic, aesthetic preferences, and budget to recommend the perfect tiles for your space.'
  },
  {
    question: 'Do you offer home delivery in Lucknow?',
    answer: 'Yes, we provide doorstep delivery across Lucknow and surrounding areas. Delivery charges may vary based on location and order quantity. Contact us for specific delivery estimates.'
  },
  {
    question: 'Can I visit your showroom to see products before purchasing?',
    answer: 'Absolutely! We encourage showroom visits. Our Lucknow showroom displays a wide range of tiles, bathroom fittings, and plumbing solutions. Visit us at Hardoi Road, opposite Azad Patakhe, Mahipatmau, Lucknow. Open all days 10:00 AM - 8:30 PM.'
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept all major payment methods including cash, UPI (Google Pay, PhonePe, Paytm), bank transfers (NEFT/RTGS), and credit/debit cards.'
  },
  {
    question: 'How are your prices compared to other showrooms?',
    answer: 'We offer competitive, transparent pricing with no hidden costs. As authorized dealers, we provide genuine products at fair market rates. Our bulk purchasing allows us to pass savings directly to customers.'
  },
  {
    question: 'Do you provide quotes for construction projects?',
    answer: 'Yes, we provide detailed material quotations for residential and commercial projects. Share your requirements or project plans, and our team will prepare a comprehensive quote with product recommendations and pricing.'
  }
];
